<template>
    <div class="search-frame">
        <!-- Champ de recherche -->
        <input type="text" v-model="search" placeholder="Rechercher..." class="search-bar" @focus="dropdownOpen = true"
            @blur="onBlur" />

        <!-- Liste déroulante -->
        <div v-if="dropdownOpen" class="dropdown">
            <div v-for="(option, index) in filteredOptions" :key="index" class="option" @click="selectOption(option)">
                {{ option.label }}
            </div>

            <!-- Message si aucune option trouvée -->
            <div v-if="filteredOptions.length === 0" class="not-found-msg">
                Aucun résultat trouvé
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['options', 'modelValue'],
    emits: ["update:modelValue"],
    data() {
        return {
            search: "",
            dropdownOpen: false,
        }
    },
    computed: {
        filteredOptions() {
            const normalize = str =>
                str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();

            const normalizedSearch = normalize(this.search);

            return this.options.filter(option =>
                normalize(option.label).includes(normalizedSearch)
            );
        }
    },
    methods: {
        selectOption(option) {
            this.$emit('update:modelValue', option.key);
            this.search = option.label;
            this.dropdownOpen = false;
        },
        onBlur() {
            // Donne le temps au clic sur une option de se faire avant de fermer
            setTimeout(() => {
                this.dropdownOpen = false;
            }, 100);
        }

    },
    mounted() {
        const currentOption = this.options.find(o => o.key == this.modelValue);
        if (currentOption) {
            this.search = currentOption.label
        }
    }
}
</script>

<style scoped>
.search-frame {
    position: relative;
    display: flex;
    flex-wrap: wrap;
}

.search-bar {
    flex-grow: 1;
    flex-basis: 100%;
    font-size: 18px;
    font-weight: 200;
    text-align: left;
    border-radius: 5px;
    padding: 5px;
    border: 1px solid lightgrey;
}

/* Position absolue de la liste déroulante */
.dropdown {
    position: absolute;
    top: 100%;
    /* juste en dessous de l'input */
    left: 0;
    right: 0;
    z-index: 10;
    /* au-dessus des autres éléments */
    background-color: white;
    border: 1px solid lightgrey;
    border-top: none;
    border-radius: 0 0 5px 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-height: 200px;
    overflow-y: auto;
}

.option {
    cursor: pointer;
    box-sizing: border-box;
    padding: 5px 10px;
    font-size: 14px;
    font-weight: 200;
    background-color: white;
    width: 100%;
    color: #1C1C1E;
}

.option:hover {
    background-color: #f0f0f0;
}

.not-found-msg {
    padding: 5px 10px;
    color: #999;
    font-size: 13px;
}
</style>